import { pathJoin } from 'src/reducers/routing/utils'

export const createFeeMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  'period-and-fee': pathJoin(prefix)('period-and-fee').chain,
})
